import { gql } from "@apollo/client";

export const CREATE_SIGNATURE = gql`
mutation CreateEmailSignature($createEmailSignatureInput: CreateEmailSignatureInput!) {
  createEmailSignature(createEmailSignatureInput: $createEmailSignatureInput) {
    _id
    signature
    userId
  }
}
`


export const SIGNATURE_UPLOAD_FILE = gql`
mutation UploadSignatureFile($file: Upload!) {
  uploadSignatureFile(file: $file) {
    key
    url
  }
}
`